/**
 * Sends dimensions event when the element is resized.
 *
 * @unstable
 */

import { Directive, ElementRef, EventEmitter, inject, NgZone, OnDestroy, OnInit, Output } from '@angular/core';

export interface ElementResizeEvent {
  dimensions: { width: number; height: number };
  position: { left: number; top: number };
}

@Directive({
  selector: '[elementResize]',
  standalone: false,
})
export class ElementResize implements OnInit, OnDestroy {
  readonly zone = inject(NgZone);
  readonly elRef = inject<ElementRef<HTMLElement>>(ElementRef);

  private ro?: ResizeObserver;

  @Output()
  readonly elementResize = new EventEmitter<ElementResizeEvent>();

  ngOnInit(): void {
    this.zone.runOutsideAngular(() => {
      this.ro = new ResizeObserver(([{ contentRect }]: ResizeObserverEntry[]) =>
        this.zone.run(() =>
          this.elementResize.emit({
            dimensions: { width: contentRect.width, height: contentRect.height },
            position: { left: contentRect.left, top: contentRect.top },
          }),
        ),
      );

      this.ro.observe(this.elRef.nativeElement);
    });
  }

  ngOnDestroy(): void {
    this.ro?.disconnect();
  }
}
